<script lang="ts">
  export let hash: string;
  export let width: number;
  export let height: number;

  import { statsStore } from '../common/statsStore.js';
  import P5 from 'p5-svelte';
  import ReverieLib from '@ludans/reverie';

  let rendering = true;

  const sketch = (p) => {

    let qrCodeDiv;

    p.setup = () => {
      p.createCanvas(width, height);
      p.noLoop();

      qrCodeDiv = p.createDiv();
      qrCodeDiv.position(0, 0);
    };

    p.draw = () => {

      const stats = ReverieLib.libGenReverie(p, width, height, hash);
      statsStore.update(() => stats);

      rendering = false;
    };

  };
</script>

<span aria-busy={rendering}>
  <P5 {sketch} />
</span>
